import React from 'react';

import collaborationSections from './collaborationData';

const EventGallery = ({ images, title }) => {
  if (!images.length) return null;
  return (
    <div className="collaboration-event-gallery" aria-label={`${title} photographs`}>
      {images.map((image, index) => (
        <figure key={image}>
          <img src={image} alt={`${title} ${index + 1}`} loading="lazy" />
        </figure>
      ))}
    </div>
  );
};

const PartnerLogos = ({ logos, title }) => {
  if (!logos.length) return null;
  return (
    <div className="collaboration-partners" aria-label={`${title} partner organizations`}>
      <span>Collaborating organizations</span>
      <div className="collaboration-logo-row">
        {logos.map((logo, index) => (
          <figure key={logo}>
            <img src={logo} alt={`${title} partner logo ${index + 1}`} loading="lazy" />
          </figure>
        ))}
      </div>
    </div>
  );
};

const CollaborationSections = () => (
  <div className="collaboration-groups">
    {collaborationSections.map((section, sectionIndex) => (
      <section className="collaboration-group" key={section.title} aria-labelledby={`collaboration-group-${sectionIndex}`}>
        <header className="collaboration-group-header">
          <p className="section-eyebrow">COLLABORATION PORTFOLIO · {String(sectionIndex + 1).padStart(2, '0')}</p>
          <h2 id={`collaboration-group-${sectionIndex}`}>{section.title}</h2>
          <div className="collaborations-title-line" aria-hidden="true" />
        </header>
        {section.events.map((event, eventIndex) => (
          <article className={`collaboration-event ${eventIndex % 2 ? 'collaboration-event-grey' : ''}`} key={event.title}>
            <div className="collaboration-event-inner">
              <div className="collaboration-event-heading">
                <span className="collaboration-event-number">{String(eventIndex + 1).padStart(2, '0')}</span>
                <h3>{event.title}</h3>
              </div>
              <p className="collaboration-event-body">{event.body}</p>
              <PartnerLogos logos={event.logos} title={event.title} />
              <EventGallery images={event.images} title={event.title} />
            </div>
          </article>
        ))}
      </section>
    ))}
  </div>
);

export default CollaborationSections;
